//  Version : 0.0.1
//  Author : VISHNU
// LastEdit : KARTHEESWARAN
// LASTADD : Removed excel Redux
// MODFIED DATE:12-11-2025
import { docodeHexResponse } from '../../_common/common.utils';
import ArrearFollowupActionTypes from './arrear-followup-report.type';

const INITIAL_STATE = {
	// ARREAR FOLLOW UP LIST STATUS
	getArrearFollowupListResponse: null,
	getArrearFollowupListArr: [],
};

const arrearFollowupReportReducer = (state = INITIAL_STATE, action: any) => {
	switch (action.type) {
		/*************** GET ARREAR FOLLOWUP LIST START ************/
		case ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_SUCCESS:
			return {
				...state,
				getArrearFollowupListResponse: action.payload,
				getArrearFollowupListArr: docodeHexResponse(
					action.payload,
					'GetArrearFollowUpReportKey',
				),
			};

		case ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_FAILURE:
			return {
				...state,
				getArrearFollowupListResponse: action.payload,
				getArrearFollowupListArr: null,
			};

		case ArrearFollowupActionTypes.GET_ARREAR_FOLLOWUP_LIST_RESPONSE_CHANGED:
			return { ...state, getArrearFollowupListResponse: null };

		/*************** GET ARREAR FOLLOWUP LIST END ************/
		default:
			return state;
	}
};

export default arrearFollowupReportReducer;
